import React from 'react';
import BadRequestContent from 'src/components/badRequest/MainContent';

function BadRequest() {
  return (
    <div className={{ margin: '0px', padding: '0px' }}>
      <BadRequestContent />
    </div>
  );
}
export default BadRequest;
